module.exports = __webpack_public_path__ + "img/cart.18aab072.svg";